// extracted by mini-css-extract-plugin
export default {"packsContainer":"Packs_packsContainer__OEc6y","packsBoxContainer":"Packs_packsBoxContainer__VAvZp","newPackButton":"Packs_newPackButton__ICGN1","penFill":"Packs_penFill__cSg0z"};